import React from 'react';
import ReactTooltip from 'react-tooltip';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const tagStyle = {
	display: 'inline-block',
	cursor: 'pointer',
};
const textTagStyle = {
	fontWeight: '800',
};

const capsuleTagStyle = {
	color: 'white',
	borderRadius: '20px',
	padding: '2px 10px',
	fontSize: '12px',
	fontWeight: '700',

};

const toolTipStyle = {
	color: 'white',
	padding: '9px 14px',
	maxWidth: '300px',
};

const getTagStyle = (design, color) => {
	if (design === 'capsule') {
		return { ...tagStyle, ...capsuleTagStyle, backgroundColor: color };
	}
	return { ...tagStyle, ...textTagStyle, color };
};
class IconTag extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			id: `tag-${Math.floor(Math.random() * Math.floor(100000))}`,
			tooltipOpen: false,
		};
		this.iconTagRef = React.createRef();
	}

	toggle = () => {
		this.setState({
			tooltipOpen: !this.state.tooltipOpen,
		});
	}
	render() {
		const {
			name, style, color, className, design, id, showTooltip, tooltip, image,
		} = this.props;
		return (
			<React.Fragment>
				<div className="d-flex f-d-row align-self-center"  data-tip={tooltip} data-place="right" data-for={`tooltip-icontag-${id}`}>

				<a id={id} className={className}><img src={`${config.cdnUrl}${image}`} alt={name} style={{ maxWidth: '25px', marginBottom: '0.75rem', ...style }} data-tip={tooltip} data-for={`tooltip-icontag-${id}`} /></a>
				{window ?
					<ReactTooltip  id={`tooltip-icontag-${id}`} ref={this.iconTagRef} data-multiline={true} />
					 : null}
					 </div>
					<style global jsx>
						{
							`
								.gi-tag{
									white-space: nowrap !important;
									align-self: center !important;
								}	
								
								.__react_component_tooltip {
									width: 300px !important;
								}
							`
						}
					</style>
			</React.Fragment>
		);
	}
}

IconTag.defaultProps = {
	className: 'gi-tag',

};
export default IconTag;
